import { useReduxState } from 'hooks';
import { FlexContainer, MoreOptions, Search } from 'components/common';
import { useBoxContext } from 'components/common/box';
import {
  CalendarEventParticipantsEditCustomAttributes,
  CalendarEventParticipantsPromoteFromQueue,
  CalendarEventParticipantsRemove
} from '.';

interface Props {
  allUserIds: number[];
  matchingUserIds: number[];
  onSearch: ({ search }: { search: string }) => void;
  updateUsers: () => Promise<void>;
}

const CalendarEventParticipantsQueuedHeader = ({
  allUserIds,
  matchingUserIds,
  onSearch,
  updateUsers
}: Props) => {
  const { messages } = useReduxState();

  const { selectedItems } = useBoxContext();

  const selectedUserIds = Object.keys(selectedItems).map((key) => Number(key));

  return (
    <FlexContainer style={{ gap: 10 }}>
      <div style={{ minWidth: 240 }}>
        <Search
          onSearch={onSearch}
          placeholder={messages.usersSearchUsers}
          size="header"
        />
      </div>

      <MoreOptions category="lighter" styleContentButtons={false}>
        <CalendarEventParticipantsEditCustomAttributes
          selectedUserIds={
            selectedUserIds?.length ? selectedUserIds : matchingUserIds
          }
          updateUsers={updateUsers}
        />

        <CalendarEventParticipantsPromoteFromQueue
          allUserIds={allUserIds}
          selectedUserIds={
            selectedUserIds?.length ? selectedUserIds : matchingUserIds
          }
          updateUsers={updateUsers}
        />

        <CalendarEventParticipantsRemove
          selectedUserIds={
            selectedUserIds?.length ? selectedUserIds : matchingUserIds
          }
          status="queued"
          updateUsers={updateUsers}
        />
      </MoreOptions>
    </FlexContainer>
  );
};

export default CalendarEventParticipantsQueuedHeader;
